/* ==========================================================================
   EKATRONIX — Mega-Menü schließen beim Klick daneben

   Eingebunden in sections/header.liquid, direkt neben ek-mega-menu.css.

   WARUM ÜBERHAUPT
   Das Theme schließt ein offenes Menü nur über "focusout" am <details>.
   Das greift aber nur, wenn der Klick den Fokus überhaupt bewegt - ein Klick
   auf eine leere Stelle der Seite tut das in mehreren Browsern nicht, und
   das Menü blieb offen stehen. Hier hängt deshalb ein eigener Zuhörer am
   Dokument, der jeden Klick außerhalb von <header-menu> als "zu" wertet.

   WARUM DAS MIT DEM MEGA-MENÜ ZUSAMMENSPIELT
   Die unsichtbare Hülle .ek-mega läuft über die volle Fensterbreite, ist
   aber in ek-mega-menu.css auf pointer-events: none gesetzt. Ein Klick neben
   die weiße Karte geht dadurch hindurch und landet auf der Seite dahinter -
   und genau den fängt dieser Zuhörer. Ohne pointer-events: none würde die
   Hülle den Klick schlucken und nichts würde passieren.

   Zusätzlich schließt die Esc-Taste, wie man es von Menüs erwartet.

   Geschlossen wird über die close()-Methode des Theme-Bausteins
   (DetailsDisclosure.close in assets/global.js). Dadurch laufen die
   Aufräumarbeiten des Themes normal mit - das "toggle"-Ereignis feuert, die
   Einblend-Animation wird zurückgesetzt und der Sticky-Header darf sich
   wieder verstecken. Nur zur Sicherheit gibt es darunter einen Rückweg, der
   das Attribut selbst entfernt, falls die Methode einmal fehlt.
   ========================================================================== */

(function () {
  'use strict';

  var OPEN_SELECTOR = 'header-menu > details[open]';

  function openMenus() {
    return document.querySelectorAll(OPEN_SELECTOR);
  }

  function closeMenu(details) {
    var headerMenu = details.closest('header-menu');

    if (headerMenu && typeof headerMenu.close === 'function') {
      headerMenu.close();
    } else {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    if (headerMenu) {
      /* Reste aus dem Überfahren-Betrieb: Die Klasse und die Ebenen-Variable
         setzt das Theme beim Öffnen per Maus. Wir räumen sie mit weg, damit
         der Kopfbereich nicht unnötig über dem Seiteninhalt liegen bleibt. */
      headerMenu.classList.remove('open');
      headerMenu.style.setProperty('--header-zindex', '0');
    }

    document
      .querySelector('.drawer-menu--on-scroll')
      ?.classList.remove('drawer-menu--on-scroll--paused');
  }

  function closeAll() {
    openMenus().forEach(closeMenu);
  }

  /* Klick irgendwo im Dokument.

     In der Erfassungsphase (drittes Argument true), damit der Zuhörer auch
     dann läuft, wenn ein anderes Skript den Klick unterwegs anhält.

     Alles innerhalb von <header-menu> ist "drinnen": der Menüpunkt in der
     Leiste, die weiße Karte und jeder Link darin. Nur was außerhalb liegt,
     schließt - also die Seite, aber auch Suchfeld, Konto und Warenkorb in
     der Kopfzeile. */
  document.addEventListener(
    'click',
    function (evt) {
      if (!openMenus().length) return;
      if (evt.target.closest && evt.target.closest('header-menu')) return;
      closeAll();
    },
    true
  );

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' && evt.key !== 'Esc') return;
    if (!openMenus().length) return;
    closeAll();
  });
})();
